(function () {

    // Toggle class on click
    $('[data-toggle-class]').on('click', function (e) {
        e.preventDefault();
        const config = $(this).data('toggle-class').split(':');
        const $target = $(config[0]);
        const className = config[1];

        $target.toggleClass(className);
    });

    // Enable tooltips
    $('[data-toggle="tooltip"]').tooltip();

})();

(function () {

    // Get the sidebar element.
    const $websiteNav = $('#main-nav');

    // When then toggle button is clicked move the sidebar into and out of view.
    $('#btn-toggle-nav').on('click', function () {
        $websiteNav.toggleClass('d-none');

        if (!$websiteNav.hasClass('d-none')) {
            window.scrollTo(0, 0);
        }
    });

})();

(function () {

    // Get the breadcrumbs element.
    const breadcrumbs = document.querySelector('#breadcrumbs');

    // If the breadcrumbs is on the page, scroll it as far to the right as possible.
    if (breadcrumbs) {
        breadcrumbs.scrollLeft = breadcrumbs.scrollWidth;
    }

})();

(function () {

    // Look for any forms that need to be guarded.
    const $guardableForms = $('form[data-form-guard]');

    $guardableForms.on('submit', function (e) {

        // Cache reference to the form.
        const $form = $(this);

        // Hide any dropdowns currently being shown.
        $('.dropdown-toggle').dropdown('hide');

        // If the form is marked as being successfully guarded, allow the original event to continue.
        if (Boolean($form.data('form-guarded')) === true) {
            return true;
        }

        // Prevent the form from being submitted.
        e.preventDefault();

        // Extract the message to show to the user.
        const message = $form.data('form-guard');

        // Ask the user to confirm/cancel the action.
        const confirmed = confirm(message);

        // If the user confirmed the action, mark the form as guarded and re-submit.
        if (confirmed) {
            $form.attr('data-form-guarded', 'true');
            $form.submit();
        }

    });

})();